export enum FavouriteType {
  PUNTUAL = 'PUNTUAL',
  RECURRENT = 'RECURRENT',
}
